import { SalaryInfo } from 'features/managers-perfomance/salary/salary';

type Props = {
  managerId: number | null;
};

export const Salary = ({ managerId }: Props) => {
  return <SalaryInfo managerId={managerId} />;
};
